import { PropsWithChildren, useState } from 'react';

import { ResponsibleUsersContext } from './ResponsibleUsersProvider.hooks';

export const ResponsibleUsersProvider = ({ children }: PropsWithChildren) => {
  const [users, setUsers] = useState<string[] | undefined>([]);

  return (
    <ResponsibleUsersContext.Provider
      value={{
        setUsers,
        users,
      }}
    >
      {children}
    </ResponsibleUsersContext.Provider>
  );
};
